module.exports = __webpack_public_path__ + "static/media/Marotte_Chene_aurea_MT2-03-Panel.377e6be2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Chene_aurea_MT2-03-Panel.jpg
// module id = 947
// module chunks = 37